import { Title, Subtitle } from 'components/DesktopTable/Empty/styles';
import React from 'react';

const UnsubscriptionsEmpty = () => {
  return (
    <>
      <Title>Nothing to see here...</Title>
      <Subtitle>There are no unsubscriptions</Subtitle>
    </>
  );
};

export default UnsubscriptionsEmpty;
